import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { PreviousRouteService } from 'src/app/services/previousRouteService';
import Device from 'src/app/services/device.model';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, OnDestroy {
  public device: Device = new Device();
  public devices: Array<Device> = [];
  public fileUploadForm: FormGroup;
  public submitted = false;
  public enableDisablePageLoader: boolean = false;
  public submitting: boolean = false;

  constructor(
    private toastrService: ToastrService,
    public formBuilder: FormBuilder,
    public deviceService: DeviceService,
    private locationStrategy: LocationStrategy,
    private previousRouteService: PreviousRouteService
  ) {
    this.device = new Device();
    this.fileUploadForm = this.formBuilder.group({
      serial_number: ['', Validators.required],
      fileName: ['', Validators.required],
      filePath: ['', Validators.required],
      fileData: ['', Validators.required],
    });
  }

  public async ngOnInit() {
    try {
      window.scrollTo(0, 0);
      this.enableDisablePageLoader = true;
      this.previousRouteService.setPreviousRoute(this.locationStrategy.path());
      this.devices = await this.deviceService.getAllDevices();
      this.enableDisablePageLoader = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error);
      this.enableDisablePageLoader = false;
    }
  }

  public ngOnDestroy(): void {
    this.deviceService.cancelOnGoingHttpRequests();
  }

  public get fileUploadFormValidation() {
    return this.fileUploadForm.controls;
  }

  public async fileUpload() {
    this.submitted = true;
    if (this.fileUploadForm.invalid) {
      return;
    }
    const formData = this.fileUploadForm.value;
    this.device.serial_number = formData.serial_number;
    this.device.fileName = formData.fileName;
    this.device.filePath = formData.filePath;
    this.device.fileData = formData.fileData;

    try {
      this.submitting = true;
      const res = await this.deviceService.fileDownload(this.device);
      if (res && res.download) {
        this.toastrService.success('File uploaded successfully', '', { timeOut: 2000 });
        this.submitted = false;
        this.device = new Device();
        this.fileUploadForm.reset();
      }
      this.submitting = false;
    } catch (error) {
      this.toastrService.error(error?.error?.message || error?.message || error || 'Path does not exist');
      this.submitting = false;
    }
  }
}

